import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class HeadersService  {



  setHeaders(params?: Array<any>) {

    const token = JSON.parse(localStorage.getItem('token'));
    const accessToken = token?.access_token;
    const reqData = {
      headers: {
        Authorization: `Bearer ${accessToken}`,

      },
    };
    if (params) {
      const reqParams = {};
      Object.keys(params).map((k) => {
        reqParams[k] = params[k];
      });
      reqData['params'] = reqParams;
    }
    return reqData;
  }


}
